import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { usuariosRoutesMap } from './UsuariosRoutesMap'

const AppGestion = Loadable(lazy(() => import('./view/listado/Usuarios')))
const AppNuevo = Loadable(lazy(() => import('./view/registro/UsuarioRegistro')))
const AppActualizar = Loadable(lazy(() => import('./view/actualizar/UsuarioActualizar')))

const usuarioRoutes = [
  {
    path: usuariosRoutesMap.gestion.path,
    element: <AppGestion />,
    auth: authRoles.admin,
  },
  {
    path: usuariosRoutesMap.nuevo.path,
    element: <AppNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${usuariosRoutesMap.modificar.path}/:id`,
    element: <AppActualizar />,
    auth: authRoles.admin,
  },
]

export default usuarioRoutes
